<script setup>
import { toRef } from 'vue';
import { useChannelIcon, useChannelColor } from './provider';
import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
  showBadge: {
    type: Boolean,
    default: false,
  },
});

const channelIcon = useChannelIcon(toRef(props, 'inbox'));
const channelColor = useChannelColor(toRef(props, 'inbox'));
</script>

<template>
  <Icon :icon="channelIcon" :class="channelColor" />
</template>
